import { render, staticRenderFns } from "./priceManagerMatrix.vue?vue&type=template&id=a6c4bbd8&scoped=true"
import script from "./priceManagerMatrix.vue?vue&type=script&lang=js"
export * from "./priceManagerMatrix.vue?vue&type=script&lang=js"
import style0 from "./priceManagerMatrix.vue?vue&type=style&index=0&id=a6c4bbd8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6c4bbd8",
  null
  
)

export default component.exports